import { Snackbar } from "@mui/material"
import React from "react"
import { useEffect, usestate } from "react"
import ls from 'local-storage';

export function Toaster(props){
    useEffect(()=>{
        // console.log("snack bar run")
        // console.log(props.open)
        // console.log(props)
    },[props.open])

    function handleClose(){
        props.setOpen(false)
        ls.remove("errorMessage")
    }

    return (
            <Snackbar
                anchorOrigin={{vertical:"top",horizontal:"center"}}
                open={props.open}
                autoHideDuration={props.ahd}
                onClose={handleClose}
                message={props.message}
                ContentProps={{
                    sx:{
                        background:props.color ? props.color : "green",
                        borderRadius:"10px"
                    }
                }}
            />
    )
}